import { useLocation } from 'react-router-dom'
import { Checkbox, Label, MenuContent } from 'src/app/components'
import MenuContentMall from 'src/app/components/Feedback/MenuContent/MenuContent.mall'
import { useFilterMenuSalesPromoPrizeListHook } from './FilterMenuSalesPromoPrizeList.hook'

interface FilterMenuSalesPromoPrizeListProps {
  withClaimedStatus: boolean
  withClaimedLocation: boolean
}
function FilterMenuSalesPromoPrizeList(props: FilterMenuSalesPromoPrizeListProps) {

  const location = useLocation();
  const state = useFilterMenuSalesPromoPrizeListHook()
  const statusMaster = state.master.claimedStatuses

  const renderStatusItem = (item: typeof state.master.claimedStatuses[0]) => {
    const mappedLabel = mapStatusLabel(item.label);
    const mappedValue = mapStatusLabel(item.value);
    return (
      <Checkbox className='ml-1'
        {...state.filterContext.registerCheckbox({ name: 'prize_statuses', value: mappedValue })}
        label={mappedLabel}
        key={item.value}
      />
    )
  }

  const mapStatusLabel = (status: string): string => {
    const statusMap: Record<string, string> = {
      Claimed: 'Claimed',
      'Not Yet': 'Not Yet',
      Expired: 'Expired',
    };

    const statusKeyMap: Record<string, string> = {
      CLAIMED: 'CLAIMED',
      PENDING: 'PENDING',
      EXPIRED: 'EXPIRED',
    };

    // Check if the status matches the event, apply mapping if true; else return as is
    if (extractEvent() === 'event') {
      return statusMap[status] || status;
    } else if (extractEvent() === 'session') {
      return statusMap[status] || statusKeyMap[status];
    }
    return status; // Return the original status if the condition is not met
  };

  // Extract the `event` part from the URL
  const extractEvent = () => {
    const pathSegments = location.pathname.split('/');
    return pathSegments[pathSegments.length - 1]; // Get the last segment as `event`
  };

  return (
    <MenuContent>
      {props.withClaimedLocation && <MenuContentMall label='Claimed Location' useName={true} filterContext={state.filterContext} />}
      {props.withClaimedStatus && <div>
        <Label>Claimed Status</Label>
        <div className='flex-col grid grid-cols-2 justify-normal max-h-[170px] no-scrollbar overflow-auto pt-1 w-full gap-6'>
          {statusMaster.map(renderStatusItem)}
        </div>
      </div>}
    </MenuContent>
  )
}

FilterMenuSalesPromoPrizeList.defaultProps = {
  withClaimedStatus: true,
  withClaimedLocation: true,
} as FilterMenuSalesPromoPrizeListProps

export { FilterMenuSalesPromoPrizeList }
